module.exports = __webpack_public_path__ + "img/4-6.3278e155.svg";